import io from 'socket.io-client'
import browser from 'detect-browser'

class Socket {

  constructor () {
    let opts = {}

    // Force usage of websockets in browsers >= IE10
    if (browser.name !== 'ie' || browser.version >= 10) {
      opts.transports = ['websocket']
    }

    this.socket = io('/', opts)
  }

}

const singleInstance = new Socket()

export default singleInstance.socket



// WEBPACK FOOTER //
// ./src/providers/socket.js